import React from 'react';
import './MockDataLabel.css';

export type MockDataLabelPosition = 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
export type MockDataLabelColor = 'blue' | 'red' | 'green' | 'yellow' | 'purple';

export interface MockDataLabelProps {
  /** Label text */
  text?: string;
  /** Position of the label */
  position?: MockDataLabelPosition;
  /** Color theme */
  color?: MockDataLabelColor;
  /** Children to wrap (optional) */
  children?: React.ReactNode;
}

/**
 * MockDataLabel - A floating label to mark mock data pages in Storybook.
 * Can be used as a wrapper or standalone.
 */
export const MockDataLabel: React.FC<MockDataLabelProps> = ({
  text = 'Mock Data',
  position = 'top-right',
  color = 'blue',
  children,
}) => {
  return (
    <div className="mock-data-label-wrapper">
      <div
        className={`mock-data-label mock-data-label--${position} mock-data-label--${color}`}
      >
        <span className="mock-data-label__text">{text}</span>
      </div>
      {children}
    </div>
  );
};

export default MockDataLabel;
